import { render } from "./offeringList.vue?vue&type=template&id=cb923c86&scoped=true"
import script from "./offeringList.vue?vue&type=script&lang=js"
export * from "./offeringList.vue?vue&type=script&lang=js"

import "./offeringList.vue?vue&type=style&index=0&id=cb923c86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb923c86"]])

export default __exports__